import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import ArticlePreviewSection from './components/ArticlePreviewSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategorySection />
      <ContentSection />
      <ArticlePreviewSection />
      <Footer />
    </main>
  );
}